import { DEBUG_MODE, IS_PRODUCTION, IS_STAGING } from 'utils/constants'
import { notification } from 'antd'
import { push } from 'react-router-redux'
import localStore from 'store'
import { store } from 'config/store'
import english from 'locales/en-US'
import german from 'locales/de-DE'
import { errorEvent } from 'services/events'

const deduplicate = (type, notificationObj) => {
  if (!localStore.get(type)) {
    localStore.set(type, true)
    notification.open({
      ...notificationObj,
      onClose: () => {
        localStore.set(type, false)
      },
    })
  }
}

const translate = (id) => {
  const language = localStore.get('app.settings.locale')
  const message = language === 'de-DE' ? german.messages[id] : english.messages[id]
  return message
}

// WORKAROUND METHOD until we update backend with graphql-errors with type(!) in extensions
export const getEmployeeLinkErrorType = (error) => {
  if (error.message.includes('overridden')) return 'overridden'
  if (error.message.includes('revoked')) return 'revoked'
  if (error.message.includes('expired')) return 'expired'
  return 'general'
}

// Custom error handling based on type (show user notification/message)
const switchErrorType = (error) => {
  if (!IS_PRODUCTION) {
    notification.open({
      type: 'warning',
      message: error.message,
    })
  }
  // TODO: Types are currently not sent anymore from backend. See bug: https://github.com/graphql-java-kickstart/graphql-spring-boot/pull/318
  // const { type, message } = error
  // switch (type) {
  //   case 'BadCredentialsException': // failure due to invalid/expired access token
  //   case 'AccessDeniedException':
  //     // Prevent duplicate messages
  //     deduplicate(type, {
  //       type: 'error',
  //       message: translate('errors.accessDeniedException.title'),
  //       description: translate('errors.accessDeniedException.description'),
  //     })
  //     store.dispatch(push('/access-denied'))
  //     break
  //   case 'OptimisticLockException': // failure due to simultanuous editing
  //   case 'ObjectOptimisticLockingFailureException':
  //     notification.open({
  //       type: 'warning',
  //       message: translate('errors.optimisticLockException.title'),
  //       description: translate('errors.optimisticLockException.description'),
  //     })
  //     break
  //   case 'InvitationRevokedException':
  //     store.dispatch(push('/overview'))
  //     notification.open({
  //       type: 'warning',
  //       message: translate('errors.invitationRevokedException.title'),
  //       description: translate('errors.invitationRevokedException.description'),
  //     })
  //     break
  //   case 'CustomException': // Any custom backend message (validation, revoked, etc.)
  //     notification.open({
  //       type: 'warning',
  //       message,
  //       onClick: () => store.dispatch(push('/report-bug')),
  //     })
  //     break
  //   case 'ArithmeticException': // failure due to invalid operation (e.g. corrupt project)
  //     notification.open({
  //       type: 'warning',
  //       message: translate('errors.arithmeticException.title'),
  //       onClick: () => store.dispatch(push('/report-bug')),
  //     })
  //     break
  //   // TODO: Improve error messages for this types
  //   case 'DataIntegrityViolationException': // failure due to deletion of a referenced entity
  //   case 'IllegalArgumentException': // failure due to illegal argument (or internal)
  //   case 'EntityNotFoundException':
  //   case 'CoercingParseValueException':
  //   case 'NonNullableValueCoercedAsNullException':
  //   default:
  // }
}

// Used in graphql-client => Called on every graphql error
export function handleGraphQLExceptions(graphQLErrors) {
  graphQLErrors.forEach((error) => {
    switchErrorType(error)
    handleQueryException(error)
  })
}

// Used in graphql-client => Called on every network error
export function handleNetworkException(networkError) {
  // Prevent duplicate messages
  deduplicate('network-exception', {
    type: 'error',
    message: translate('errors.networkException.title'),
    description: translate('errors.networkException.description'),
    onClick: () => store.dispatch(push('/report-bug')),
  })
  handleError('Network', networkError)
}

// CUSTOM ERRORS
export function handleMutationException(error) {
  handleError('MUTATION', error)
}

export function handleQueryException(error) {
  handleError('QUERY', error)
}

export function handleComponentException(error, info) {
  handleError('COMPONENT', error, info)

  if (error.type === 'BadCredentialsException') store.dispatch(push('/access-denied'))
}

export function handlePageException(error, info) {
  handleError('PAGE', error, info)

  if (error.type === 'BadCredentialsException') store.dispatch(push('/access-denied'))
}

export function handleAppException(error) {
  const nonCritical = nonCriticalError(error)
  const errorCategory = `APP${nonCritical ? '_NON_CRITICAL' : ''}`

  // console print only on localhost
  if (IS_PRODUCTION || IS_STAGING) {
    errorEvent(errorCategory, error)
  } else if (DEBUG_MODE) {
    handleError(`APP${nonCritical ? '_NON_CRITICAL' : ''}`, error)
  }

  if (nonCritical) return
  if (IS_PRODUCTION || IS_STAGING) store.dispatch(push('/error-log'))
}

function handleError(category, error, info) {
  console.log(`${category} exception reported.`, error, info)
  if (IS_PRODUCTION || IS_STAGING) errorEvent(category, error)
}

const nonCriticalError = (error) => {
  // Filter non critical errors such as "ResizeObserver"
  if (!(error && error.message)) return false
  if (error.message.includes('ResizeObserver')) return true
  if (error.message.includes('Script error.')) return true // Safari does not specify error specifically

  return false
}
